import { Box, type BoxProps } from '@chakra-ui/react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkBreaks from 'remark-breaks';
import rehypeHighlight from 'rehype-highlight';
import './livecoach.scss';

/**
 * Markdown for the Live Coach copilot replies. Same engine + styling contract as `PrepMarkdown` /
 * `CoachMarkdown` (react-markdown + remark-gfm + remark-breaks, styled via the `.livecoach-md`
 * class), so the three copilots render identically.
 */
export function LiveCoachMarkdown({
  children,
  ...boxProps
}: { children: string } & BoxProps) {
  return (
    <Box className="livecoach-md" {...boxProps}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm, remarkBreaks]}
        rehypePlugins={[
          [rehypeHighlight, { detect: true, ignoreMissing: true }],
        ]}
      >
        {children || ''}
      </ReactMarkdown>
    </Box>
  );
}

export default LiveCoachMarkdown;
